// extracted by mini-css-extract-plugin
export default {"buttons-container":"Input_buttons-container__W8e+S","align-center":"Input_align-center__w3QpW","inputLabel":"Input_inputLabel__qL+vA","input":"Input_input__kSzkm"};